export const getBlogDateFormatted = (date) => {
    const [year, month, day] = date.split(' ')[0].split('-')

    let temp = new Date(year, month - 1, day);
    temp = temp.toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
    return temp;
};